import ReactDOM from "react-dom";
import * as Icon from "react-feather";
import { useTranslation } from "react-i18next";
import { capitalize } from "../../utils/manipulateText";
import LoadingBackDrop from "./LoadingBackDrop";

const Modal = ({
  isVisible,
  onClose,
  title,
  children,
  loading = false,
  customClass = "",
}) => {
  const { t } = useTranslation();

  if (!isVisible) return null;

  const modalContent = (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-80">
      <div
        className={`bg-white p-3 flex flex-col items-center justify-between rounded-md border border-gray-300 ${customClass}`}
      >
        {loading && <LoadingBackDrop />}

        <div className="w-full p-3 flex items-center justify-between">
          <h3 className="font-semibold text-m mr-16">{capitalize(t(title))}</h3>
          <span className="cursor-pointer" onClick={onClose}>
            <Icon.X width={20} height={20} />
          </span>
        </div>
        {children}
      </div>
    </div>
  );

  return ReactDOM.createPortal(
    modalContent,
    document.getElementById("modal-root") || document.body
  );
};

export default Modal;
